import { useMutation } from '@tanstack/react-query'

import type { UseMutationResult } from '@tanstack/react-query'
import type {
  ICreateOrUpdateMwmAppChecklist,
  ICreateOrUpdatePublishingAppChecklist,
  ICreateOrUpdateReleaseChecklist,
} from '~/types/checklist'
import type { IAppVersion } from '~/types/version'

import {
  createOrUpdateMwmAppChecklist,
  createOrUpdateReleaseChecklist,
  createPublishingAppChecklist,
  updatePublishingAppChecklist,
} from '~/api/checklists'

//////// MUTATIONS //////////
export const useCreateOrUpdateReleaseChecklistMutation = (): UseMutationResult<
  IAppVersion,
  unknown,
  ICreateOrUpdateReleaseChecklist
> => {
  return useMutation({ mutationFn: createOrUpdateReleaseChecklist })
}

export const useCreatePublishingAppChecklistMutation = (): UseMutationResult<
  IAppVersion,
  unknown,
  ICreateOrUpdatePublishingAppChecklist & { appId: string }
> => {
  return useMutation({ mutationFn: createPublishingAppChecklist })
}

export const useUpdatePublishingAppChecklistMutation = (): UseMutationResult<
  IAppVersion,
  unknown,
  ICreateOrUpdatePublishingAppChecklist & { appId: string; checklistId: string }
> => {
  return useMutation({ mutationFn: updatePublishingAppChecklist })
}

export const useCreateOrUpdateMwmAppChecklistMutation = (): UseMutationResult<
  IAppVersion,
  unknown,
  ICreateOrUpdateMwmAppChecklist & { appId: string; checklistId?: string }
> => {
  return useMutation({ mutationFn: createOrUpdateMwmAppChecklist })
}
